/**
 * Similarweb - Website Traffic, AI Traffic & SEO Checker
 *
 * Traffic-analytics panel exposed to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 6.12.21.
 */
import { probeFetch, probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'hoklmmgfnpapgjgcpechhaamimifchmp';
export const similarweb: ExtensionDefinition = {
  id: ID,
  name: "Similarweb - Website Traffic, AI Traffic & SEO Checker",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Traffic-analytics panel exposed to every origin.",
  signals: [
    { id: 'war-panel-panel-html', kind: 'web-accessible-resource',
      description: 'Fetch panel/panel.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'panel/panel.html') },
    { id: 'war-images-bouncerate-svg', kind: 'web-accessible-resource',
      description: 'Load images/BounceRate.svg via <img>, exposed to every origin.',
      weight: 0.5, run: () => probeImage(ID, 'images/BounceRate.svg') },
  ],
};
